import { useCallback } from 'react';
export const useAutocompleteSelection = ({ onChange, setInputValue, setDebouncedSearchValue, setIsOpen, setActiveIndex, }) => {
    const selectItem = useCallback((item) => {
        setInputValue(item.name);
        setDebouncedSearchValue(item.name);
        onChange(item.name, item.code);
        setIsOpen(false);
        setActiveIndex(-1);
    }, [
        onChange,
        setActiveIndex,
        setDebouncedSearchValue,
        setInputValue,
        setIsOpen,
    ]);
    const handleSuggestionMouseDown = (e, item) => {
        e.preventDefault();
        selectItem(item);
    };
    const handleSuggestionClick = (item) => {
        selectItem(item);
    };
    return {
        selectItem,
        handleSuggestionMouseDown,
        handleSuggestionClick,
    };
};
